module.exports = __webpack_public_path__ + "img/verification-dm.39c9696d.svg";